import { Skeleton } from "@particles/index"

import { useJobPreviewCard } from "@pages/Jobs/JobList/views/JobTimelineView/JobPreviewCard/JobPreviewCard.context"

import styles from "./JobPreviewServiceName.module.scss"
import { JobPreviewServiceNameProps } from "./JobPreviewServiceName.types"

export default function JobPreviewServiceName(props: JobPreviewServiceNameProps) {
    const { service_name } = props
    const { isLoading } = useJobPreviewCard()

    if (isLoading && !service_name) {
        return <Skeleton width={120} height={20} />
    }

    return <div className={styles.base}>{service_name}</div>
}
